export const paymentType = (type?: string, extraValue?: number) => {
  return type?.toUpperCase() === 'CASH' && extraValue ? 'Híbrido' : type ?? '';
};
